var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef, useCallback, } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Button, Typography, Tabs, TabList, Tab, Stack, Input, Snackbar, Chip, Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, Sheet, RadioGroup, Grid, Dropdown, MenuButton, Menu, MenuItem, IconButton, } from "@mui/joy";
import Radio, { radioClasses } from "@mui/joy/Radio";
import { tabClasses } from "@mui/joy/Tab";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import AddIcon from "@mui/icons-material/Add";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/Error";
import ChatIcon from "@mui/icons-material/Chat";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useFlows } from "../../data/hooks/useFlows";
import { TwilioCallComponent } from "../../components/common/TwilioCallComponent";
import { useCreditPricing } from "../../data/hooks/useCreditPricing";
import Sidepane from "../../components/ui/Sidepane";
import AIAgentsList from "./components/AIAgentList";
import TemplateMetadataEditor from "./components/TemplateMetadataEditor"; // Import the new component
import Prompts from "./components/Prompts";
import Plugins from "./components/Plugins";
import Configuration from "./components/Configuration";
import Deployment from "./components/Deployment";
import axios from "axios";
import Escalation from "./components/Escalation";
import { useWebsite } from "../../data/hooks/useWebsite";
import { DOWORK_WIDGET_TESTING, DOWORK_POPUP_OPENED } from "../../constants";
import MoreVert from "@mui/icons-material/MoreVert";
export var AIAgents = function () {
    var _a, _b, _c, _d;
    var _e, _f, _g, _h, _j, _k;
    var _l = useFlows(), flows = _l.flows, voices = _l.voices, sttModels = _l.sttModels, llmModels = _l.llmModels, templates = _l.templates, getFlows = _l.getFlows, getVoices = _l.getVoices, getSTTModels = _l.getSTTModels, getLLMModels = _l.getLLMModels, createNewFlow = _l.createNewFlow, deleteFlow = _l.deleteFlow, updateFlow = _l.updateFlow, getTemplates = _l.getTemplates, markAsTemplate = _l.markAsTemplate, unMarkAsTemplate = _l.unMarkAsTemplate;
    var _m = useState(true), isFlowsLoading = _m[0], setIsFlowsLoading = _m[1];
    var _o = useSearchParams(), searchParams = _o[0], setSearchParams = _o[1];
    var _p = useState(null), selectedFlow = _p[0], setSelectedFlow = _p[1];
    var _q = useState(""), flowName = _q[0], setFlowName = _q[1];
    var _r = useState(false), isFlowNameEditing = _r[0], setIsFlowNameEditing = _r[1];
    var _s = useState(0), tabIndex = _s[0], setTabIndex = _s[1];
    var _t = useState(false), flowShouldBeSaved = _t[0], setFlowShouldBeSaved = _t[1];
    var _u = useState(false), isSaving = _u[0], setIsSaving = _u[1];
    var _v = useState(false), isSaveConfirmationOpen = _v[0], setIsSaveConfirmationOpen = _v[1];
    var _w = useState(null), errorMessage = _w[0], setErrorMessage = _w[1];
    var _x = useState([]), invalidFields = _x[0], setInvalidFields = _x[1];
    var _y = useState(false), isKnowledgeBaseEnabled = _y[0], setIsKnowledgeBaseEnabled = _y[1];
    var inputRef = useRef(null);
    var _z = useWebsite(), widgetScript = _z.widgetScript, getWidgetScript = _z.getWidgetScript;
    var _0 = useState(false), isNewAgentModalOpen = _0[0], setIsNewAgentModalOpen = _0[1];
    var _1 = useState(null), selectedTemplateFlowId = _1[0], setSelectedTemplateFlowId = _1[1];
    var _2 = useState(false), isTemplatesLoading = _2[0], setIsTemplatesLoading = _2[1];
    var _3 = useState(false), isFlowAdding = _3[0], setIsFlowAdding = _3[1];
    var _4 = useState(false), isTemplateMetadataModalOpen = _4[0], setIsTemplateMetadataModalOpen = _4[1];
    var calculatePricing = useCreditPricing().calculatePricing;
    var _5 = useState(null), agentPricing = _5[0], setAgentPricing = _5[1];
    var _6 = useState(false), isPricingLoading = _6[0], setIsPricingLoading = _6[1];
    var defaultWebhookArgs = {
        httpMethod: "POST",
        url: "",
        headers: {},
        authorizationType: "",
        apiKey: "",
        username: "",
        password: "",
        usernameFieldName: "",
        passwordFieldName: "",
        accessTokenUrl: "",
        accessTokenHttpMethod: "POST",
        accessTokenFieldName: "",
    };
    var defaultEmailPostCallActionArgs = {
        emailTo: "",
    };
    var getArgsObject = function (type) {
        return type === "webhook"
            ? defaultWebhookArgs
            : defaultEmailPostCallActionArgs;
    };
    var setScript = useCallback(function () {
        // Inject script if it's the right path and script is loaded
        if (location.pathname === "/ai-agents" && widgetScript) {
            var script = document.createElement("script");
            script.id = "dowork-script";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = widgetScript
                .replace('<script type="text/javascript">', "")
                .replace("</script>", "");
            document.body.appendChild(script);
        }
    }, [widgetScript]);
    var _7 = useState(false), isDeleteConfirmationOpen = _7[0], setIsDeleteConfirmationOpen = _7[1];
    var handleDeleteFlow = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!selectedFlow)
                return [2 /*return*/];
            setIsDeleteConfirmationOpen(true); // Show the confirmation modal
            return [2 /*return*/];
        });
    }); }, [selectedFlow]);
    var confirmDeleteFlow = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlows, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    setIsDeleteConfirmationOpen(false);
                    if (!(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteFlow(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.id)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, getFlows()];
                case 3:
                    updatedFlows = _a.sent();
                    if (updatedFlows.length > 0) {
                        selectFlow(updatedFlows[0].id); // Select the first available flow
                    }
                    else {
                        setSelectedFlow(null);
                    }
                    setErrorMessage(null);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    handleError("Failed to delete the flow. Please try again.");
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [selectedFlow, deleteFlow, getFlows]);
    var cancelDeleteFlow = useCallback(function () {
        setIsDeleteConfirmationOpen(false);
    }, []);
    var onTest = useCallback(function () {
        sessionStorage.setItem(DOWORK_POPUP_OPENED, "true");
        sessionStorage.setItem(DOWORK_WIDGET_TESTING, "true");
        setScript();
    }, [setScript]);
    var onMarkAsTemplate = useCallback(function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, markAsTemplate(flowId)];
                case 1:
                    _a.sent();
                    updatedFlow = __assign(__assign({}, selectedFlow), { isWorkspaceTemplate: true });
                    setSelectedFlow(updatedFlow);
                    return [4 /*yield*/, getFlows()];
                case 2:
                    _a.sent();
                    setIsSaveConfirmationOpen(true);
                    return [2 /*return*/];
            }
        });
    }); }, [selectedFlow]);
    var onUnMarkAsTemplate = useCallback(function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlow;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, unMarkAsTemplate(flowId)];
                case 1:
                    _a.sent();
                    updatedFlow = __assign(__assign({}, selectedFlow), { isWorkspaceTemplate: false });
                    setSelectedFlow(updatedFlow);
                    return [4 /*yield*/, getFlows()];
                case 2:
                    _a.sent();
                    setIsSaveConfirmationOpen(true);
                    return [2 /*return*/];
            }
        });
    }); }, [selectedFlow]);
    var handleFlowNameClick = useCallback(function () {
        setIsFlowNameEditing(true);
    }, []);
    var handleFlowNameChange = useCallback(function (event) {
        setFlowName(event.target.value);
    }, []);
    var selectFlow = useCallback(function (flowId) {
        searchParams.set("id", flowId.toString());
        setSearchParams(searchParams);
        setFlowShouldBeSaved(false);
    }, [searchParams, setSearchParams]);
    //Template metadata
    var closeTemplateMetadataModal = useCallback(function () {
        setIsTemplateMetadataModalOpen(false);
    }, []);
    //Configuration
    var handleDescriptionChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowDescription: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleVoicemailDetectedMessageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowVoicemailDetectedMessage: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleEndPointingChange = useCallback(function (event, newValue) {
        var value = newValue;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { endPointing: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUtteranceEndChange = useCallback(function (event, newValue) {
        var value = newValue;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { utteranceEnd: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHidePIIDataChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { hidePIIData: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseTypingSoundDataChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { useTypingSound: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleDoNotRecordCallsDataChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { doNotRecordCalls: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleOutboundModeChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { outboundMode: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleOptOutChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { optOut: checked })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleLLMModelNameChange = useCallback(function (event, newValue) {
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { llmModelName: newValue })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSTTModelNameChange = useCallback(function (event, newValue) {
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { sttModel: newValue })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleVoiceChange = useCallback(function (event, selectedVoice) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { voiceId: selectedVoice.id, voice: selectedVoice }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Prompts
    var handleWelcomeMessageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowWelcomeMessage: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleIntroductionChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowIntroduction: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleInstructionChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { flowInstruction: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleFAQChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) { return (__assign(__assign({}, prevFlow), { faqSection: value })); });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSupportedLanguageChange = useCallback(function (event, value) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { supportedLanguages: value }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    // HubSpot
    var handleHubSpotIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotDeploymentConfig: __assign(__assign({}, prevFlow.hubSpotDeploymentConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotUserIdChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotDeploymentConfig: __assign(__assign({}, prevFlow.hubSpotDeploymentConfig), { doworkUserIdInHubspot: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotActivationMessageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotDeploymentConfig: __assign(__assign({}, prevFlow.hubSpotDeploymentConfig), { activationMessage: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Knowledge Base
    var handleIsKnowledgeBaseEnabled = useCallback(function (event) {
        setIsKnowledgeBaseEnabled(event.target.checked);
        if (event.target.checked) {
            if (!(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.useKnowledgeBasePlugin) &&
                !(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.stepByStepTroubleshootingPlugin)) {
                setSelectedFlow(function (prevFlow) {
                    return (__assign(__assign({}, prevFlow), { useKnowledgeBasePlugin: true, stepByStepTroubleshootingPlugin: false }));
                });
            }
        }
        else {
            setSelectedFlow(function (prevFlow) {
                return (__assign(__assign({}, prevFlow), { useKnowledgeBasePlugin: false, stepByStepTroubleshootingPlugin: false }));
            });
        }
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseKnowledgeBaseChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useKnowledgeBasePlugin: checked, stepByStepTroubleshootingPlugin: !checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseUploadedFilesChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useUploadedFiles: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseWebsiteContentChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useWebsiteContent: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseAutoGeneratedArticlesChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useAutoGeneratedArticles: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseAutoGeneratedInstructionsChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useAutoGeneratedInstructions: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleUseDraftAutoGeneratedContentChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { useDraftAutoGeneratedContent: checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleStepByStepTroubleshootingPluginChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { stepByStepTroubleshootingPlugin: checked, useKnowledgeBasePlugin: !checked }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //SIP
    var handleSIPIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSIPConfigurationUpdate = useCallback(function (config) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { id: config.id }) }));
        });
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { domainName: config.domainName }) }));
        });
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { userName: config.userName }) }));
        });
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipDeploymentConfig: __assign(__assign({}, prevFlow.sipDeploymentConfig), { password: config.password }) }));
        });
    }, []);
    //SIP REEFER
    var handleSIPEscalationIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipEscalationConfig: __assign(__assign({}, prevFlow.sipEscalationConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleSIPReferURIChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { sipEscalationConfig: __assign(__assign({}, prevFlow.sipEscalationConfig), { sipBackUrl: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Call Forwarding
    var handleCallForwardingEscalationNumberChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { callForwardingEscalationConfig: __assign(__assign({}, prevFlow.callForwardingEscalationConfig), { forwardToNumber: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleCallForwardingEscalationIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { callForwardingEscalationConfig: __assign(__assign({}, prevFlow.callForwardingEscalationConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //HubSpot Ticket
    var handleHubSpotEscalationIsEnabledChange = useCallback(function (event) {
        var checked = event.target.checked;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { isEnabled: checked }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotTicketPipelineChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { ticketHsPipeline: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotTicketPipelineStageChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { ticketHsPipelineStage: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleHubSpotTicketPriorityChange = useCallback(function (event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { hubSpotEscalationConfig: __assign(__assign({}, prevFlow.hubSpotEscalationConfig), { ticketHsTicketPriority: value }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Data Collection
    var handlePluginNameChange = useCallback(function (pluginIndex, event) {
        var value = event.target.value;
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex ? __assign(__assign({}, plugin), { pluginName: value }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleStartWithPluginChange = useCallback(function (pluginIndex) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) { return (__assign(__assign({}, plugin), { startWithFirstVariableQuestion: i === pluginIndex })); }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleStartWithPluginEnabledChange = useCallback(function (isEnabled) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) { return (__assign(__assign({}, plugin), { startWithFirstVariableQuestion: isEnabled &&
                        (prevFlow.plugins.some(function (p) { return p.startWithFirstVariableQuestion; })
                            ? plugin.startWithFirstVariableQuestion
                            : i === 0) })); }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginIsEnabledChange = useCallback(function (pluginIndex, isEnabled) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex ? __assign(__assign({}, plugin), { isEnabled: isEnabled }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleNewPlugin = useCallback(function () {
        if (!selectedFlow)
            return;
        var newPlugin = {
            id: 0,
            isEnabled: true,
            flowId: selectedFlow.id,
            pluginType: "DataCollectionPlugin",
            storeCollectDataAsJson: true,
            makeActionEnabled: true,
            pluginName: "New Plugin",
            pluginVariables: [],
            startWithFirstVariableQuestion: false,
            pluginAction: {
                type: "webhook",
                injectResult: true,
                actionDescription: "",
                args: "",
                argsObject: {
                    httpMethod: "POST",
                    url: "",
                    headers: {},
                    authorizationType: "",
                    apiKey: "",
                    username: "",
                    password: "",
                    usernameFieldName: "",
                    passwordFieldName: "",
                    accessTokenUrl: "",
                    accessTokenHttpMethod: "POST",
                    accessTokenFieldName: "",
                },
            },
        };
        setSelectedFlow(function (prevFlow) {
            return __assign(__assign({}, prevFlow), { plugins: __spreadArray(__spreadArray([], prevFlow.plugins, true), [newPlugin], false) });
        });
        setFlowShouldBeSaved(true);
    }, [selectedFlow]);
    var handlePluginVariablePropertyChange = useCallback(function (pluginIndex, variableIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                var _a;
                                return j === variableIndex
                                    ? __assign(__assign({}, variable), (_a = {}, _a[propertyName] = newValue, _a)) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginNewVariable = useCallback(function (pluginIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: __spreadArray(__spreadArray([], plugin.pluginVariables, true), [
                                { type: "string", isEnabled: true, enumValues: [] },
                            ], false) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginDeleteVariable = useCallback(function (pluginIndex, variableIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.filter(function (_, j) { return j !== variableIndex; }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionTypeChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { type: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginInjectResultChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { injectResult: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionDescriptionChange = useCallback(function (pluginIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { actionDescription: newValue }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsPropertyChange = useCallback(function (pluginIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    var _a;
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), (_a = {}, _a[propertyName] = newValue, _a)) }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsNewHeader = useCallback(function (pluginIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    var _a;
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { headers: __assign(__assign({}, plugin.pluginAction.argsObject.headers), (_a = {}, _a[""] = "", _a)) }) }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsUpdateHeader = useCallback(function (pluginIndex, headerKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedHeaders = __assign({}, plugin.pluginAction.argsObject.headers);
                    if (updateType === "key") {
                        // Update the key by creating a new entry and deleting the old one
                        if (Object.prototype.hasOwnProperty.call(updatedHeaders, headerKey)) {
                            var headerValue = updatedHeaders[headerKey];
                            delete updatedHeaders[headerKey];
                            updatedHeaders[newValue] = headerValue;
                        }
                    }
                    else if (updateType === "value") {
                        // Update the value directly
                        updatedHeaders[headerKey] = newValue;
                    }
                    return __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsDeleteHeader = useCallback(function (pluginIndex, headerKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedHeaders = __assign({}, plugin.pluginAction.argsObject.headers);
                    delete updatedHeaders[headerKey];
                    return __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsNewAdditionalBodyVariable = useCallback(function (pluginIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    var _a;
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { additionalBodyVariables: __assign(__assign({}, plugin.pluginAction.argsObject
                                        .additionalBodyVariables), (_a = {}, _a[""] = "", _a)) }) }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsUpdateAdditionalBodyVariable = useCallback(function (pluginIndex, bodyKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedAdditionalBodyVars = __assign({}, plugin.pluginAction.argsObject.additionalBodyVariables);
                    if (updateType === "key") {
                        // Update the key by creating a new entry and deleting the old one
                        if (Object.prototype.hasOwnProperty.call(updatedAdditionalBodyVars, bodyKey)) {
                            var bodyValue = updatedAdditionalBodyVars[bodyKey];
                            delete updatedAdditionalBodyVars[bodyKey];
                            updatedAdditionalBodyVars[newValue] = bodyValue;
                        }
                    }
                    else if (updateType === "value") {
                        // Update the value directly
                        updatedAdditionalBodyVars[bodyKey] = newValue;
                    }
                    return __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { additionalBodyVariables: updatedAdditionalBodyVars }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginActionArgsDeleteAdditionalBodyVariable = useCallback(function (pluginIndex, bodyKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedAdditionalBodyVars = __assign({}, plugin.pluginAction.argsObject.additionalBodyVariables);
                    delete updatedAdditionalBodyVars[bodyKey];
                    return __assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: __assign(__assign({}, plugin.pluginAction.argsObject), { additionalBodyVariables: updatedAdditionalBodyVars }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableAddEnumValue = useCallback(function (pluginIndex, varIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, vi) {
                                return vi === varIndex
                                    ? __assign(__assign({}, variable), { enumValues: __spreadArray(__spreadArray([], variable.enumValues, true), [{}], false) }) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableUpdateEnumValue = useCallback(function (pluginIndex, varIndex, enumValueIndex, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedEnumValues = plugin.pluginVariables[varIndex].enumValues.map(function (enumValue, evi) {
                        if (evi !== enumValueIndex) {
                            return enumValue;
                        }
                        return updateType === "value"
                            ? __assign(__assign({}, enumValue), { value: newValue }) : __assign(__assign({}, enumValue), { display: newValue });
                    });
                    return __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, vi) {
                            return vi === varIndex
                                ? __assign(__assign({}, variable), { enumValues: updatedEnumValues }) : variable;
                        }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleTemplateMetadataAddNew = useCallback(function () {
        setSelectedFlow(function (prevFlow) {
            return __assign(__assign({}, prevFlow), { templateMetadataDictionary: __assign(__assign({}, prevFlow.templateMetadataDictionary), { "": "" }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleTemplateMetadataDeleteKey = useCallback(function (key) {
        setSelectedFlow(function (prevFlow) {
            var updatedTemplateMetadata = __assign({}, prevFlow.templateMetadataDictionary);
            delete updatedTemplateMetadata[key]; // Remove the key
            return __assign(__assign({}, prevFlow), { templateMetadataDictionary: updatedTemplateMetadata });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleTemplateMetadataUpdateValue = useCallback(function (key, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            var updatedTemplateMetadata = __assign({}, prevFlow.templateMetadataDictionary);
            if (updateType === "key") {
                // If the key is being updated, create a new key-value pair and delete the old one
                if (newValue !== key) {
                    updatedTemplateMetadata[newValue] = updatedTemplateMetadata[key];
                    delete updatedTemplateMetadata[key];
                }
            }
            else if (updateType === "value") {
                // Update the value for the given key
                updatedTemplateMetadata[key] = newValue;
            }
            return __assign(__assign({}, prevFlow), { templateMetadataDictionary: updatedTemplateMetadata });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableDeleteEnumValue = useCallback(function (pluginIndex, varIndex, enumValueIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex) {
                        return plugin;
                    }
                    var updatedEnumValues = plugin.pluginVariables[varIndex].enumValues.filter(function (_, evi) { return evi !== enumValueIndex; });
                    return __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, vi) {
                            return vi === varIndex
                                ? __assign(__assign({}, variable), { enumValues: updatedEnumValues }) : variable;
                        }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionTypeChange = useCallback(function (pluginIndex, variableIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                return j === variableIndex
                                    ? __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { type: newValue }) }) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionDescriptionChange = useCallback(function (pluginIndex, variableIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            // Use shallow copies to avoid mutating the original state
            var newPlugins = __spreadArray([], prevFlow.plugins, true);
            var targetPlugin = __assign({}, newPlugins[pluginIndex]);
            var newPluginVariables = __spreadArray([], targetPlugin.pluginVariables, true);
            var targetVariable = __assign({}, newPluginVariables[variableIndex]);
            // Update only the action description
            targetVariable.action = __assign(__assign({}, targetVariable.action), { actionDescription: newValue });
            // Reassign the updated variable and plugin back to their respective arrays
            newPluginVariables[variableIndex] = targetVariable;
            targetPlugin.pluginVariables = newPluginVariables;
            newPlugins[pluginIndex] = targetPlugin;
            // Return the new flow state with updated plugins
            return __assign(__assign({}, prevFlow), { plugins: newPlugins });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionArgsPropertyChange = useCallback(function (pluginIndex, variableIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                var _a;
                                return j === variableIndex
                                    ? __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), (_a = {}, _a[propertyName] = newValue, _a)) }) }) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionArgsNewHeader = useCallback(function (pluginIndex, variableIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                var _a;
                                return j === variableIndex
                                    ? __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), { headers: __assign(__assign({}, variable.action.argsObject.headers), (_a = {}, _a[""] = "", _a)) }) }) }) : variable;
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionArgsUpdateHeader = useCallback(function (pluginIndex, variableIndex, headerKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                if (j !== variableIndex)
                                    return variable;
                                var updatedHeaders = __assign({}, variable.action.argsObject.headers);
                                if (updateType === "key") {
                                    if (headerKey in updatedHeaders) {
                                        var headerValue = updatedHeaders[headerKey];
                                        delete updatedHeaders[headerKey];
                                        updatedHeaders[newValue] = headerValue;
                                    }
                                }
                                else {
                                    updatedHeaders[headerKey] = newValue;
                                }
                                return __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), { headers: updatedHeaders }) }) });
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionArgsDeleteHeader = useCallback(function (pluginIndex, variableIndex, headerKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                if (j !== variableIndex)
                                    return variable;
                                var updatedHeaders = __assign({}, variable.action.argsObject.headers);
                                delete updatedHeaders[headerKey];
                                return __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), { headers: updatedHeaders }) }) });
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionArgsDeleteAdditionalBodyVariable = useCallback(function (pluginIndex, variableIndex, bodyKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                if (j !== variableIndex)
                                    return variable;
                                var updatedBodyVariables = __assign({}, variable.action.argsObject
                                    .additionalBodyVariables);
                                delete updatedBodyVariables[bodyKey];
                                return __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), { additionalBodyVariables: updatedBodyVariables }) }) });
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginVariableActionArgsNewAdditionalBodyVariable = useCallback(function (pluginIndex, variableIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                var _a;
                                if (j !== variableIndex)
                                    return variable;
                                return __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), { additionalBodyVariables: __assign(__assign({}, variable.action.argsObject
                                                .additionalBodyVariables), (_a = {}, _a[""] = "", _a)) }) }) });
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleReorderPluginVVariables = function (pluginIndex, newVariables) {
        // e.g. setSelectedFlow in your example
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, idx) {
                    return idx === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: newVariables }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    };
    var handlePluginVariableActionArgsUpdateAdditionalBodyVariable = useCallback(function (pluginIndex, variableIndex, bodyKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex
                        ? __assign(__assign({}, plugin), { pluginVariables: plugin.pluginVariables.map(function (variable, j) {
                                if (j !== variableIndex)
                                    return variable;
                                var updatedBodyVariables = __assign({}, variable.action.argsObject
                                    .additionalBodyVariables);
                                if (updateType === "key") {
                                    if (bodyKey in updatedBodyVariables) {
                                        var bodyValue = updatedBodyVariables[bodyKey];
                                        delete updatedBodyVariables[bodyKey];
                                        updatedBodyVariables[newValue] = bodyValue;
                                    }
                                }
                                else {
                                    updatedBodyVariables[bodyKey] = newValue;
                                }
                                return __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { argsObject: __assign(__assign({}, variable.action.argsObject), { additionalBodyVariables: updatedBodyVariables }) }) });
                            }) }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    //conversationFlowPostCallActions
    var handleNewPostCallAction = useCallback(function () {
        try {
            if (!selectedFlow) {
                console.warn("No selectedFlow available");
                return;
            }
            var newAction_1 = {
                id: 0,
                isEnabled: true,
                flowId: selectedFlow.id,
                postCallAction: {
                    type: "webhook",
                    args: "",
                    postCallExecutionDelayInSeconds: 0,
                    argsObject: {
                        httpMethod: "POST",
                        url: "",
                        headers: {},
                        authorizationType: "",
                        apiKey: "",
                        username: "",
                        password: "",
                        usernameFieldName: "",
                        passwordFieldName: "",
                        accessTokenUrl: "",
                        accessTokenHttpMethod: "POST",
                        accessTokenFieldName: "",
                    },
                },
            };
            setSelectedFlow(function (prevFlow) {
                if (!prevFlow) {
                    console.warn("Previous flow is null or undefined");
                    return prevFlow;
                }
                var updatedFlow = __assign(__assign({}, prevFlow), { postCallActions: __spreadArray(__spreadArray([], prevFlow.postCallActions, true), [newAction_1], false) });
                return updatedFlow;
            });
            setFlowShouldBeSaved(true);
        }
        catch (error) {
            console.error("Error occurred in handleNewPostCallAction:", error);
        }
    }, [selectedFlow]);
    var handleVariableActionEnabledChange = useCallback(function (pluginIndex, variableIndex, newValue) {
        try {
            if (!selectedFlow) {
                console.warn("No selectedFlow available");
                return;
            }
            setSelectedFlow(function (prevFlow) {
                if (!prevFlow) {
                    console.warn("Previous flow is null or undefined");
                    return prevFlow;
                }
                var updatedPlugins = prevFlow.plugins.map(function (plugin, i) {
                    if (i !== pluginIndex)
                        return plugin;
                    var updatedVariables = plugin.pluginVariables.map(function (variable, j) {
                        if (j !== variableIndex)
                            return variable;
                        if (newValue) {
                            // Enable action: Add default action if it doesn't exist, or set isEnabled to true
                            return __assign(__assign({}, variable), { action: variable.action
                                    ? __assign(__assign({}, variable.action), { isEnabled: true }) : {
                                    isEnabled: true,
                                    type: "webhook",
                                    actionDescription: "",
                                    args: "",
                                    argsObject: {
                                        httpMethod: "POST",
                                        url: "",
                                        headers: {},
                                        authorizationType: "",
                                        apiKey: "",
                                        username: "",
                                        password: "",
                                        usernameFieldName: "",
                                        passwordFieldName: "",
                                        accessTokenUrl: "",
                                        accessTokenHttpMethod: "POST",
                                        accessTokenFieldName: "",
                                    },
                                } });
                        }
                        else {
                            // Disable action: Set isEnabled to false if action exists
                            if (variable.action) {
                                return __assign(__assign({}, variable), { action: __assign(__assign({}, variable.action), { isEnabled: false }) });
                            }
                        }
                        return variable;
                    });
                    return __assign(__assign({}, plugin), { pluginVariables: updatedVariables });
                });
                return __assign(__assign({}, prevFlow), { plugins: updatedPlugins });
            });
            setFlowShouldBeSaved(true);
        }
        catch (error) {
            console.error("Error occurred in handleVariableActionEnabledChange:", error);
        }
    }, [selectedFlow]);
    var handlePostCallActionDelete = useCallback(function (actionIndex) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow; // Return early if prevFlow is not set
            // Remove the post call action at the specified index
            var updatedPostCallActions = prevFlow.postCallActions.filter(function (_, index) { return index !== actionIndex; });
            return __assign(__assign({}, prevFlow), { postCallActions: updatedPostCallActions });
        });
        setFlowShouldBeSaved(true); // Mark the flow as needing to be saved
    }, []);
    var handlePostCallActionTypeChange = useCallback(function (actionIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow; // Return early if prevFlow is not set
            return __assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    return i === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { type: newValue, argsObject: getArgsObject(newValue) }) }) : action;
                }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionDelayInSecondsChange = useCallback(function (actionIndex, newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow; // Return early if prevFlow is not set
            return __assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    return i === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { postCallExecutionDelayInSeconds: newValue }) }) : action;
                }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsPropertyChange = useCallback(function (actionIndex, propertyName, newValue) {
        setSelectedFlow(function (prevFlow) {
            var _a;
            var updatedFlow = __assign(__assign({}, prevFlow), { postCallActions: (_a = prevFlow === null || prevFlow === void 0 ? void 0 : prevFlow.postCallActions) === null || _a === void 0 ? void 0 : _a.map(function (action, index) {
                    var _a;
                    return index === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), (_a = {}, _a[propertyName] = newValue, _a)) }) }) : action;
                }) });
            return updatedFlow;
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsNewHeader = useCallback(function (actionIndex) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    var _a;
                    return i === actionIndex
                        ? __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), { headers: __assign(__assign({}, action.postCallAction.argsObject.headers), (_a = {}, _a[""] = "", _a)) }) }) }) : action;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsUpdateHeader = useCallback(function (actionIndex, headerKey, newValue, updateType) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    if (i !== actionIndex) {
                        return action;
                    }
                    var updatedHeaders = __assign({}, action.postCallAction.argsObject.headers);
                    if (updateType === "key") {
                        // Update the key by creating a new entry and deleting the old one
                        if (Object.prototype.hasOwnProperty.call(updatedHeaders, headerKey)) {
                            var headerValue = updatedHeaders[headerKey];
                            delete updatedHeaders[headerKey];
                            updatedHeaders[newValue] = headerValue;
                        }
                    }
                    else if (updateType === "value") {
                        // Update the value directly
                        updatedHeaders[headerKey] = newValue;
                    }
                    return __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePostCallActionArgsDeleteHeader = useCallback(function (actionIndex, headerKey) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { postCallActions: prevFlow.postCallActions.map(function (action, i) {
                    if (i !== actionIndex) {
                        return action;
                    }
                    var updatedHeaders = __assign({}, action.postCallAction.argsObject.headers);
                    delete updatedHeaders[headerKey];
                    return __assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: __assign(__assign({}, action.postCallAction.argsObject), { headers: updatedHeaders }) }) });
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    // Inactivity Hangup Config handlers
    var handleInactivityWarningInSecondsChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { warnAfterInactivityInSeconds: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleInactivityWarningMessageChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { warnAfterInactivityMessage: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleInactivityHangupInSecondsChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { hangupAfterInactivityInSeconds: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleInactivityHangupMessageChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { hangupAfterInactivityMessage: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleGlobalCallDurationInMinutesChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { globalCallDurationThresholdInMinutes: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleFirstInteractionInactivityMessageChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { firstInteractionInactivityMessage: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleFirstInteractionInactivityDelayChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { inactivityHangupConfig: __assign(__assign({}, prevFlow.inactivityHangupConfig), { firstInteractionInactivityDelayInSeconds: newValue }) });
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handleDictationModeTimerIntervalChange = useCallback(function (newValue) {
        setSelectedFlow(function (prevFlow) {
            if (!prevFlow)
                return prevFlow;
            return __assign(__assign({}, prevFlow), { dictationModeTimerIntervalInMilliseconds: newValue });
        });
        setFlowShouldBeSaved(true);
    }, []);
    //Conversation flow
    var onFlowSelect = function (flowId) {
        selectFlow(flowId);
    };
    var onNewFlow = function () { return __awaiter(void 0, void 0, void 0, function () {
        var templates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsTemplatesLoading(true);
                    return [4 /*yield*/, getTemplates()];
                case 1:
                    templates = _a.sent();
                    setSelectedTemplateFlowId(templates[1].id);
                    setIsNewAgentModalOpen(true);
                    setIsTemplatesLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onAddNewFlow = function () {
        var addNewFlow = function () { return __awaiter(void 0, void 0, void 0, function () {
            var flow;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsFlowAdding(true);
                        return [4 /*yield*/, createNewFlow(selectedTemplateFlowId)];
                    case 1:
                        flow = _a.sent();
                        return [4 /*yield*/, getFlows()];
                    case 2:
                        _a.sent();
                        selectFlow(flow.id);
                        setIsNewAgentModalOpen(false);
                        setIsFlowAdding(false);
                        return [2 /*return*/];
                }
            });
        }); };
        addNewFlow();
    };
    var validateModel = useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var PLUGIN_NAME_REGEX = /^[a-zA-Z0-9_]+$/;
        var invalid = [];
        if ((_a = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _a === void 0 ? void 0 : _a.isEnabled) {
            if (!selectedFlow.hubSpotDeploymentConfig.activationMessage) {
                invalid.push({
                    field: "hubSpotDeploymentConfig.activationMessage",
                    error: "",
                });
            }
            if (!selectedFlow.hubSpotDeploymentConfig.doworkUserIdInHubspot) {
                invalid.push({
                    field: "hubSpotDeploymentConfig.doworkUserIdInHubspot",
                    error: "",
                });
            }
        }
        if ((_b = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sipEscalationConfig) === null || _b === void 0 ? void 0 : _b.isEnabled) {
            if (!selectedFlow.sipEscalationConfig.sipBackUrl) {
                invalid.push({ field: "sipEscalationConfig.sipBackUrl", error: "" });
            }
        }
        var flowWelcomeMessageLength = ((_c = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowWelcomeMessage) === null || _c === void 0 ? void 0 : _c.length) || 0;
        if (flowWelcomeMessageLength > 2000) {
            invalid.push({
                field: "prompts.flowWelcomeMessage",
                error: "Welcome Message section exceeds the maximum allowed character count of 2000. Current length is ".concat(flowWelcomeMessageLength, "."),
            });
        }
        var flowIntroductionLength = ((_d = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowIntroduction) === null || _d === void 0 ? void 0 : _d.length) || 0;
        if (flowIntroductionLength > 2000) {
            invalid.push({
                field: "prompts.flowIntroduction",
                error: "Introduction section exceeds the maximum allowed character count of 2000. Current length is ".concat(flowIntroductionLength, "."),
            });
        }
        var flowInstructionLength = ((_e = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowInstruction) === null || _e === void 0 ? void 0 : _e.length) || 0;
        if (flowInstructionLength > 20000) {
            invalid.push({
                field: "prompts.flowInstruction",
                error: "Instructions section exceeds the maximum allowed character count of 20000. Current length is ".concat(flowInstructionLength, "."),
            });
        }
        var faqLength = ((_f = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.faqSection) === null || _f === void 0 ? void 0 : _f.length) || 0;
        if (faqLength > 16000) {
            invalid.push({
                field: "prompts.faqSection",
                error: "FAQ section exceeds the maximum allowed character count of 16000. Current length is ".concat(faqLength, "."),
            });
        }
        // Validate inactivity timing
        if (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.inactivityHangupConfig) {
            var warningSeconds = selectedFlow.inactivityHangupConfig.warnAfterInactivityInSeconds;
            var hangupSeconds = selectedFlow.inactivityHangupConfig.hangupAfterInactivityInSeconds;
            var firstInteractionDelay = (_g = selectedFlow.inactivityHangupConfig.firstInteractionInactivityDelayInSeconds) !== null && _g !== void 0 ? _g : 0;
            if (warningSeconds >= hangupSeconds) {
                invalid.push({
                    field: "inactivityTiming",
                    error: "Warning time must be less than hangup time",
                });
            }
            else if (selectedFlow.outboundMode && firstInteractionDelay >= warningSeconds) {
                invalid.push({
                    field: "inactivityTiming",
                    error: "First interaction delay must be less than regular warning time",
                });
            }
        }
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.plugins.forEach(function (plugin, pluginIndex) {
            if (!plugin.pluginName) {
                invalid.push({ field: "plugins[".concat(pluginIndex, "].name"), error: "" });
            }
            else if (!PLUGIN_NAME_REGEX.test(plugin.pluginName)) {
                invalid.push({
                    field: "plugins[".concat(pluginIndex, "].name"),
                    error: "A plugin name can contain only letters, digits, and underscore.",
                });
            }
            else if (plugin.pluginName.length > 25) {
                invalid.push({
                    field: "plugins[".concat(pluginIndex, "].name"),
                    error: "Plugin name must be 25 characters or less.",
                });
            }
            plugin.pluginVariables.forEach(function (variable, varIndex) {
                if (!variable.name) {
                    invalid.push({
                        field: "plugins[".concat(pluginIndex, "].variables[").concat(varIndex, "].name"),
                        error: "",
                    });
                }
                if (!variable.label) {
                    invalid.push({
                        field: "plugins[".concat(pluginIndex, "].variables[").concat(varIndex, "].label"),
                        error: "",
                    });
                }
            });
        });
        setInvalidFields(invalid);
        return invalid.length === 0;
    }, [
        (_e = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _e === void 0 ? void 0 : _e.isEnabled,
        (_f = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _f === void 0 ? void 0 : _f.activationMessage,
        (_g = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.hubSpotDeploymentConfig) === null || _g === void 0 ? void 0 : _g.doworkUserIdInHubspot,
        (_h = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sipEscalationConfig) === null || _h === void 0 ? void 0 : _h.isEnabled,
        (_j = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sipEscalationConfig) === null || _j === void 0 ? void 0 : _j.sipBackUrl,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowWelcomeMessage,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowIntroduction,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.flowInstruction,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.faqSection,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.plugins,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.inactivityHangupConfig,
        selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.outboundMode,
    ]);
    var onSaveFlow = useCallback(function (flow) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFlow, error_2, errors_1, errorMessages;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (validateModel() === false) {
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, 5, 6]);
                    setIsSaving(true);
                    updatedFlow = __assign(__assign({}, flow), { plugins: flow.plugins.map(function (plugin) { return (__assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { args: JSON.stringify(plugin.pluginAction.argsObject) }), pluginVariables: plugin.pluginVariables.map(function (variable) { return (__assign(__assign({}, variable), { action: variable.action
                                    ? __assign(__assign({}, variable.action), { args: JSON.stringify(variable.action.argsObject) }) : null })); }) })); }), postCallActions: flow.postCallActions.map(function (action) { return (__assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { args: JSON.stringify(action.postCallAction.argsObject) }) })); }) });
                    return [4 /*yield*/, updateFlow(updatedFlow)];
                case 2:
                    _c.sent();
                    return [4 /*yield*/, getFlows()];
                case 3:
                    _c.sent();
                    setIsSaveConfirmationOpen(true);
                    setErrorMessage(null);
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _c.sent();
                    if (axios.isAxiosError(error_2) && ((_b = (_a = error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors)) {
                        errors_1 = error_2.response.data.errors;
                        errorMessages = Object.keys(errors_1)
                            .map(function (key) {
                            // Handle both array and string formats
                            if (Array.isArray(errors_1[key])) {
                                return errors_1[key].join(", ");
                            }
                            else if (typeof errors_1[key] === "string") {
                                return errors_1[key];
                            }
                            else {
                                return "An unknown error occurred.";
                            }
                        })
                            .join("<br>");
                        handleError(errorMessages);
                    }
                    else {
                        handleError("Something went wrong, please try again.");
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setIsSaving(false);
                    setFlowShouldBeSaved(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [getFlows, updateFlow, validateModel]);
    var handleClickAway = useCallback(function () {
        if (isFlowNameEditing) {
            setIsFlowNameEditing(false);
            var updatedFlow = __assign(__assign({}, selectedFlow), { name: flowName });
            setSelectedFlow(updatedFlow);
            onSaveFlow(updatedFlow);
        }
    }, [flowName, isFlowNameEditing, selectedFlow, onSaveFlow]);
    var handleError = function (errorMessage) {
        setErrorMessage(errorMessage);
    };
    useEffect(function () {
        var fetchFlows = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, selectedFlowId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFlows()];
                    case 1:
                        data = _a.sent();
                        setIsFlowsLoading(false);
                        selectedFlowId = searchParams.get("id");
                        if (selectedFlowId === null) {
                            if (data.length > 0) {
                                selectFlow(data[0].id);
                            }
                            else {
                                onNewFlow();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchFlows();
        getWidgetScript();
        getVoices();
        getSTTModels();
        getLLMModels();
    }, []);
    // Calculate pricing when selected flow changes
    useEffect(function () {
        var fetchPricing = function () { return __awaiter(void 0, void 0, void 0, function () {
            var pricing, error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!selectedFlow) {
                            setAgentPricing(null);
                            return [2 /*return*/];
                        }
                        setIsPricingLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, calculatePricing(selectedFlow.sttModel, (_a = selectedFlow.voice) === null || _a === void 0 ? void 0 : _a.provider, selectedFlow.llmModelName)];
                    case 2:
                        pricing = _b.sent();
                        setAgentPricing(pricing);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _b.sent();
                        console.error('Error calculating pricing:', error_3);
                        setAgentPricing(null);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsPricingLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchPricing();
    }, [selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.sttModel, (_k = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.voice) === null || _k === void 0 ? void 0 : _k.provider, selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.llmModelName, selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.outboundMode]);
    useEffect(function () {
        var _a, _b;
        var selectedFlowId = searchParams.get("id");
        var selectedFlow = flows.find(function (flow) { return flow.id === String(selectedFlowId); });
        if (selectedFlow) {
            selectedFlow = __assign(__assign({}, selectedFlow), { plugins: selectedFlow.plugins.map(function (plugin) { return (__assign(__assign({}, plugin), { pluginAction: __assign(__assign({}, plugin.pluginAction), { argsObject: JSON.parse(plugin.pluginAction.args) }), pluginVariables: plugin.pluginVariables.map(function (variable) { return (__assign(__assign({}, variable), { action: variable.action
                            ? __assign(__assign({}, variable.action), { argsObject: JSON.parse(variable.action.args) }) : null })); }) })); }), postCallActions: selectedFlow.postCallActions.map(function (action) { return (__assign(__assign({}, action), { postCallAction: __assign(__assign({}, action.postCallAction), { argsObject: JSON.parse(action.postCallAction.args) }) })); }) });
        }
        setSelectedFlow(selectedFlow !== null && selectedFlow !== void 0 ? selectedFlow : null);
        setFlowName((selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.name) || "");
        setIsKnowledgeBaseEnabled(((_a = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.useKnowledgeBasePlugin) !== null && _a !== void 0 ? _a : false) ||
            ((_b = selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.stepByStepTroubleshootingPlugin) !== null && _b !== void 0 ? _b : false));
    }, [searchParams, flows]);
    useEffect(function () {
        // Cleanup function to remove the script when the component unmounts
        return function () {
            var widgetScript = document.getElementById("chat-widget-js");
            var script = document.getElementById("dowork-script");
            var websiteScript = document.getElementById("ask-website");
            localStorage.removeItem("DOWORK_SESSION_ID");
            if (widgetScript) {
                widgetScript.remove();
            }
            if (websiteScript) {
                document.body.removeChild(websiteScript);
            }
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, [location.pathname, searchParams]);
    var handlePluginStoreCollectDataAsJsonChange = useCallback(function (pluginIndex, isEnabled) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex ? __assign(__assign({}, plugin), { storeCollectDataAsJson: isEnabled }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    var handlePluginMakeActionEnabledChange = useCallback(function (pluginIndex, isEnabled) {
        setSelectedFlow(function (prevFlow) {
            return (__assign(__assign({}, prevFlow), { plugins: prevFlow.plugins.map(function (plugin, i) {
                    return i === pluginIndex ? __assign(__assign({}, plugin), { makeActionEnabled: isEnabled }) : plugin;
                }) }));
        });
        setFlowShouldBeSaved(true);
    }, []);
    return (_jsxs(Box, __assign({ display: "flex", overflow: "auto", height: "100vh" }, { children: [_jsxs(Sidepane, { children: [_jsxs(Box, __assign({ sx: {
                            p: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        } }, { children: [_jsx(Box, __assign({ sx: { alignItems: "center", gap: 1 } }, { children: _jsx(Typography, __assign({ level: "title-lg", textColor: "text.secondary", component: "h1" }, { children: "AI Agents" })) })), _jsx(Button, __assign({ startDecorator: _jsx(AddIcon, {}), onClick: function () { return onNewFlow(); }, sx: { ml: 2 }, color: "neutral", variant: "soft", loading: isTemplatesLoading }, { children: "Add New" }))] })), _jsx(AIAgentsList, { flows: flows, loading: isFlowsLoading, selectedFlowId: String(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.id), onFlowSelect: onFlowSelect })] }), _jsx(Modal, __assign({ open: isNewAgentModalOpen, onClose: function () { return setIsNewAgentModalOpen(false); }, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined", size: "lg", layout: "center" }, { children: [_jsx(ModalClose, {}), _jsx(DialogTitle, { children: "Add new Agent" }), _jsx(DialogContent, __assign({ sx: { p: 2 } }, { children: _jsxs(Stack, __assign({ spacing: 3 }, { children: [_jsx(RadioGroup, __assign({ "aria-label": "platform", overlay: true, name: "platform", sx: (_a = {
                                                flexDirection: "row",
                                                gap: 2
                                            },
                                            _a["& .".concat(radioClasses.checked)] = (_b = {},
                                                _b["& .".concat(radioClasses.action)] = {
                                                    inset: -1,
                                                    border: "3px solid",
                                                    borderColor: "primary.500",
                                                },
                                                _b),
                                            _a["& .".concat(radioClasses.radio)] = {
                                                display: "contents",
                                                "& > svg": {
                                                    zIndex: 2,
                                                    position: "absolute",
                                                    top: "-8px",
                                                    right: "-8px",
                                                    bgcolor: "background.surface",
                                                    borderRadius: "50%",
                                                },
                                            },
                                            _a) }, { children: _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: templates.map(function (template) { return (_jsx(Grid, __assign({ xs: 6 }, { children: _jsxs(Sheet, __assign({ variant: "outlined", sx: {
                                                        borderRadius: "md",
                                                        boxShadow: "sm",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: 1.5,
                                                        p: 2,
                                                        minWidth: 120,
                                                        height: 250,
                                                    } }, { children: [_jsx(Radio, { id: template.id, value: template.id, checkedIcon: _jsx(CheckCircleRoundedIcon, {}), checked: selectedTemplateFlowId === template.id, onChange: function () {
                                                                return setSelectedTemplateFlowId(template.id);
                                                            } }), _jsx(Typography, __assign({ level: "title-lg" }, { children: template.name })), _jsx(Typography, __assign({ level: "body-sm" }, { children: template.flowDescription }))] })) }), template.id)); }) })) })), _jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Button, __assign({ size: "md", variant: "solid", color: "primary", startDecorator: _jsx(CheckIcon, {}), loading: isFlowAdding, onClick: function () { return onAddNewFlow(); } }, { children: "Use Template" })) }))] })) }))] })) })), selectedFlow && (_jsxs(Box, __assign({ sx: {
                    flex: 1,
                    width: "100%",
                    overflow: "auto",
                } }, { children: [_jsxs(Box, __assign({ sx: {
                            position: "sticky",
                            top: { sm: -30, md: -20 },
                            bgcolor: "background.body",
                            zIndex: 2,
                        } }, { children: [_jsx(ClickAwayListener, __assign({ onClickAway: handleClickAway }, { children: _jsx(Box, __assign({ sx: { px: { xs: 2, md: 6 } } }, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", sx: { pt: 2 } }, { children: [_jsx(Stack, __assign({ onClick: handleFlowNameClick }, { children: isFlowNameEditing ? (_jsx(Input, { size: "lg", value: flowName, onChange: handleFlowNameChange, autoFocus: true, slotProps: { input: { inputRef: inputRef } }, onBlur: handleClickAway })) : (_jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [_jsx(Typography, __assign({ level: "h2", component: "h1", sx: { mt: 1, mb: 2, mr: 2 } }, { children: flowName })), (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.isSystemTemplate) && (_jsx(Chip, __assign({ color: "warning", variant: "outlined" }, { children: "System Template" }))), (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.isWorkspaceTemplate) && (_jsx(Chip, __assign({ color: "warning", variant: "outlined" }, { children: "Template" })))] }))) })), _jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [flowShouldBeSaved &&
                                                        (selectedFlow.isSystemTemplate ||
                                                            selectedFlow.isWorkspaceTemplate ? (_jsx(Button, __assign({ variant: "soft", color: "warning", onClick: function () { return onSaveFlow(selectedFlow); }, loading: isSaving }, { children: "Save Template" }))) : (_jsx(Button, __assign({ variant: "soft", onClick: function () { return onSaveFlow(selectedFlow); }, loading: isSaving }, { children: "Save" })))), _jsx(Snackbar, __assign({ variant: "soft", color: "success", open: isSaveConfirmationOpen, onClose: function () { return setIsSaveConfirmationOpen(false); }, anchorOrigin: { vertical: "top", horizontal: "center" }, autoHideDuration: 3000, startDecorator: _jsx(DoneIcon, {}), endDecorator: _jsx(Button, __assign({ onClick: function () { return setIsSaveConfirmationOpen(false); }, size: "sm", variant: "soft", color: "success" }, { children: "Dismiss" })) }, { children: "Your agent configuration has been saved." })), _jsx(Snackbar, __assign({ variant: "soft", color: "danger", open: errorMessage !== null, onClose: function () { return setErrorMessage(null); }, anchorOrigin: { vertical: "top", horizontal: "center" }, autoHideDuration: 3000, startDecorator: _jsx(ErrorIcon, {}), endDecorator: _jsx(Button, __assign({ onClick: function () { return setErrorMessage(null); }, size: "sm", variant: "soft", color: "danger" }, { children: "Dismiss" })) }, { children: errorMessage && (_jsx("div", { dangerouslySetInnerHTML: { __html: errorMessage } })) })), _jsx(Button, __assign({ color: "primary", variant: "soft", disabled: !widgetScript, onClick: onTest, startDecorator: _jsx(ChatIcon, {}) }, { children: "Test Chat" })), _jsx(TwilioCallComponent, { flowId: selectedFlow.id }), _jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ slots: { root: IconButton }, slotProps: {
                                                                    root: { variant: "outlined", color: "neutral" },
                                                                } }, { children: _jsx(MoreVert, {}) })), (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.isWorkspaceTemplate) ? (_jsxs(Menu, __assign({ placement: "bottom-end" }, { children: [_jsx(MenuItem, __assign({ onClick: function () { return onUnMarkAsTemplate(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.id); } }, { children: "Unmark as Template" })), _jsx(MenuItem, __assign({ onClick: function () { return setIsTemplateMetadataModalOpen(true); } }, { children: "Edit Template Metadata" }))] }))) : (_jsx(Menu, __assign({ placement: "bottom-end" }, { children: _jsx(MenuItem, __assign({ onClick: function () { return onMarkAsTemplate(selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.id); } }, { children: "Mark as Template" })) })))] })] }))] })) })) })), _jsx(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: _jsx(Tabs, __assign({ defaultValue: 0, onChange: function (event, newValue) { return setTabIndex(Number(newValue)); }, sx: {
                                        bgcolor: "transparent",
                                        flexGrow: 1,
                                    } }, { children: _jsxs(TabList, __assign({ tabFlex: 1, size: "sm", sx: (_c = {
                                                pl: { xs: 0, md: 4 },
                                                justifyContent: "left"
                                            },
                                            _c["&& .".concat(tabClasses.root)] = (_d = {
                                                    fontWeight: "600",
                                                    flex: "initial",
                                                    color: "text.tertiary"
                                                },
                                                _d["&.".concat(tabClasses.selected)] = {
                                                    bgcolor: "transparent",
                                                    color: "text.primary",
                                                    "&::after": {
                                                        height: "2px",
                                                        bgcolor: "primary.500",
                                                    },
                                                },
                                                _d),
                                            _c) }, { children: [_jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, indicatorInset: true, value: 0 }, { children: "Prompts" })), _jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, indicatorInset: true, value: 1 }, { children: "Plugins" })), _jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, indicatorInset: true, value: 2 }, { children: "Deployment" })), _jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, indicatorInset: true, value: 3 }, { children: "Escalation" })), _jsx(Tab, __assign({ sx: { borderRadius: "6px 6px 0 0" }, indicatorInset: true, value: 4 }, { children: "Configuration" }))] })) })) }))] })), _jsx(Stack, __assign({ spacing: 4, sx: {
                            display: "flex",
                            mx: "auto",
                            px: { xs: 2, md: 6 },
                            py: { xs: 2, md: 3 },
                        } }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 3, sx: { my: 1 } }, { children: [tabIndex === 0 && (_jsx(Prompts, { flow: selectedFlow, invalidFields: invalidFields, handleStartWithPluginChange: handleStartWithPluginChange, handleStartWithPluginEnabledChange: handleStartWithPluginEnabledChange, handleWelcomeMessageChange: handleWelcomeMessageChange, handleIntroductionChange: handleIntroductionChange, handleInstructionChange: handleInstructionChange, handleFAQChange: handleFAQChange })), tabIndex === 1 && (_jsx(Plugins, { flow: selectedFlow, invalidFields: invalidFields, isKnowledgeBaseEnabled: isKnowledgeBaseEnabled, onReorderVariables: handleReorderPluginVVariables, onIsKnowledgeBaseEnabled: handleIsKnowledgeBaseEnabled, onStepByStepTroubleshootingPluginChange: handleStepByStepTroubleshootingPluginChange, onUseKnowledgeBaseChange: handleUseKnowledgeBaseChange, onUseUploadedFilesChange: handleUseUploadedFilesChange, onUseAutoGeneratedArticlesChange: handleUseAutoGeneratedArticlesChange, onUseWebsiteContentChange: handleUseWebsiteContentChange, onUseDraftAutoGeneratedContentChange: handleUseDraftAutoGeneratedContentChange, onUseAutoGeneratedInstructionsChange: handleUseAutoGeneratedInstructionsChange, onNewPlugin: handleNewPlugin, onPluginNameChange: handlePluginNameChange, onPluginIsEnabledChange: handlePluginIsEnabledChange, onPluginVariablePropertyChange: handlePluginVariablePropertyChange, onPluginNewVariable: handlePluginNewVariable, onPluginDeleteVariable: handlePluginDeleteVariable, onPluginActionTypeChange: handlePluginActionTypeChange, onPluginActionDescriptionChange: handlePluginActionDescriptionChange, onPluginInjectResultChange: handlePluginInjectResultChange, onPluginActionArgsPropertyChange: handlePluginActionArgsPropertyChange, onPluginActionArgsNewHeader: handlePluginActionArgsNewHeader, onPluginActionArgsUpdateHeader: handlePluginActionArgsUpdateHeader, onPluginActionArgsDeleteHeader: handlePluginActionArgsDeleteHeader, onPluginVariableAddEnumValue: handlePluginVariableAddEnumValue, onPluginVariableUpdateEnumValue: handlePluginVariableUpdateEnumValue, onPluginVariableDeleteEnumValue: handlePluginVariableDeleteEnumValue, onPluginActionArgsDeleteAdditionalBodyVariable: handlePluginActionArgsDeleteAdditionalBodyVariable, onPluginActionArgsNewAdditionalBodyVariable: handlePluginActionArgsNewAdditionalBodyVariable, onPluginActionArgsUpdateAdditionalBodyVariable: handlePluginActionArgsUpdateAdditionalBodyVariable, onPluginStoreCollectDataAsJsonChange: handlePluginStoreCollectDataAsJsonChange, onPluginMakeActionDisabledChange: handlePluginMakeActionEnabledChange, 
                                    //VariableAction
                                    onVariableActionTypeChange: handlePluginVariableActionTypeChange, onVariableActionDescriptionChange: handlePluginVariableActionDescriptionChange, onVariableActionArgsPropertyChange: handlePluginVariableActionArgsPropertyChange, onVariableActionArgsNewHeader: handlePluginVariableActionArgsNewHeader, onVariableActionArgsUpdateHeader: handlePluginVariableActionArgsUpdateHeader, onVariableActionArgsDeleteHeader: handlePluginVariableActionArgsDeleteHeader, onVariableActionArgsDeleteAdditionalBodyVariable: handlePluginVariableActionArgsDeleteAdditionalBodyVariable, onVariableActionArgsNewAdditionalBodyVariable: handlePluginVariableActionArgsNewAdditionalBodyVariable, onVariableActionArgsUpdateAdditionalBodyVariable: handlePluginVariableActionArgsUpdateAdditionalBodyVariable, onVariableActionEnabled: handleVariableActionEnabledChange })), tabIndex === 2 && (_jsx(Deployment, { flow: selectedFlow, invalidFields: invalidFields, onError: handleError, onHubSpotIsEnabledChange: handleHubSpotIsEnabledChange, onHubSpotActivationMessageChange: handleHubSpotActivationMessageChange, onHubSpotUserIdChange: handleHubSpotUserIdChange, onSIPIsEnabledChange: handleSIPIsEnabledChange, onSIPConfigurationUpdate: handleSIPConfigurationUpdate })), tabIndex === 3 && (_jsx(Escalation, { flow: selectedFlow, invalidFields: invalidFields, onHubSpotEscalationIsEnabledChange: handleHubSpotEscalationIsEnabledChange, onHubSpotTicketPipelineChange: handleHubSpotTicketPipelineChange, onHubSpotTicketPipelineStageChange: handleHubSpotTicketPipelineStageChange, onHubSpotTicketPriorityChange: handleHubSpotTicketPriorityChange, onSIPEscalationIsEnabledChange: handleSIPEscalationIsEnabledChange, onSIPReferURIChange: handleSIPReferURIChange, onCallForwardingEscalationIsEnabledChange: handleCallForwardingEscalationIsEnabledChange, onCallForwardingEscalationNumberChange: handleCallForwardingEscalationNumberChange })), tabIndex === 4 && (_jsx(Configuration, { flow: selectedFlow, voices: voices, sttModels: sttModels, llmModels: llmModels, invalidFields: invalidFields, agentPricing: agentPricing, isPricingLoading: isPricingLoading, onDeleteFlow: handleDeleteFlow, onDescriptionChange: handleDescriptionChange, onVoicemailDetectedMessageChange: handleVoicemailDetectedMessageChange, onUtteranceEndChange: handleUtteranceEndChange, onEndPointingChange: handleEndPointingChange, onHidePIIDataChange: handleHidePIIDataChange, onOptOutChange: handleOptOutChange, onDoNotRecordCallsDataChange: handleDoNotRecordCallsDataChange, onUseTypingSoundChange: handleUseTypingSoundDataChange, onOutboundModeChange: handleOutboundModeChange, handleSupportedLanguageChange: handleSupportedLanguageChange, onLLMModelNameChange: handleLLMModelNameChange, onSTTModelNameChange: handleSTTModelNameChange, onVoiceChange: handleVoiceChange, onNewPostCallAction: handleNewPostCallAction, onPostCallActionTypeChange: handlePostCallActionTypeChange, onPostCallActionArgsPropertyChange: handlePostCallActionArgsPropertyChange, onPostCallActionArgsNewHeader: handlePostCallActionArgsNewHeader, onPostCallActionArgsUpdateHeader: handlePostCallActionArgsUpdateHeader, onPostCallActionArgsDeleteHeader: handlePostCallActionArgsDeleteHeader, onPostCallActionDelayInSecondsChange: handlePostCallActionDelayInSecondsChange, onPostCallActionDelete: handlePostCallActionDelete, 
                                    //Inactivity
                                    onInactivityWarningInSecondsChange: handleInactivityWarningInSecondsChange, onInactivityWarningMessageChange: handleInactivityWarningMessageChange, onInactivityHangupInSecondsChange: handleInactivityHangupInSecondsChange, onInactivityHangupMessageChange: handleInactivityHangupMessageChange, onGlobalCallDuraionInMinutesChange: handleGlobalCallDurationInMinutesChange, onFirstInteractionInactivityMessageChange: handleFirstInteractionInactivityMessageChange, onFirstInteractionInactivityDelayChange: handleFirstInteractionInactivityDelayChange, onDictationModeTimerIntervalChange: handleDictationModeTimerIntervalChange }))] })) }))] }))), _jsx(Modal, __assign({ open: isTemplateMetadataModalOpen, onClose: closeTemplateMetadataModal, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined" }, { children: [_jsx(ModalClose, {}), _jsx(DialogTitle, { children: "Template Metadata" }), _jsxs(DialogContent, __assign({ sx: { py: 2 } }, { children: [_jsx(TemplateMetadataEditor, { templateMetadata: (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.templateMetadataDictionary) || {}, onAddNew: handleTemplateMetadataAddNew, onDeleteKey: handleTemplateMetadataDeleteKey, onUpdateValue: handleTemplateMetadataUpdateValue }), _jsx(Stack, __assign({ alignItems: "center" }, { children: _jsx(Button, __assign({ variant: "soft", onClick: closeTemplateMetadataModal, sx: { width: "200px" } }, { children: "OK" })) }))] }))] })) })), _jsx(Modal, __assign({ open: isDeleteConfirmationOpen, onClose: cancelDeleteFlow, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined" }, { children: [_jsx(ModalClose, { onClick: cancelDeleteFlow }), _jsx(DialogTitle, { children: "Confirm Deletion" }), _jsxs(DialogContent, { children: [_jsxs(Typography, __assign({ level: "body-md" }, { children: ["Are you sure you want to delete the flow \"", selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.name, "\"?"] })), _jsx(Typography, __assign({ level: "body-md", color: "danger" }, { children: "This action cannot be undone." })), _jsxs(Stack, __assign({ direction: "row", spacing: 2, justifyContent: "flex-end", mt: 2 }, { children: [_jsx(Button, __assign({ variant: "plain", onClick: cancelDeleteFlow }, { children: "Cancel" })), _jsx(Button, __assign({ variant: "solid", color: "danger", onClick: confirmDeleteFlow }, { children: "Delete" }))] }))] })] })) }))] })));
};
